//@ts-ignore
import {DataProviderRegistry, DataProviderJSONService} from 'atomity-frontend-common';
import config from '../config';
import Auth from './Auth';

const ERROR_CODE_ACCESS_DENIED = 2;
const ERROR_MESSAGE_ACCESS_DENIED = 'Permission denied';
const AUTH_ERROR = 3;

const provider = new DataProviderJSONService(config);

const providerWrapper = {
    executeAction : async (entity: string, action: string, data: any) => {
        provider.setSessionKey(localStorage.getItem('sessionKey'));
        try {
            return await provider.executeAction(entity, action, data);
        } catch(err) {
            if (err.errorCode == AUTH_ERROR) {
                Auth.logout();
            }
            throw err;
        }
    }
}

DataProviderRegistry.add(providerWrapper);


export default providerWrapper